import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import type { Subscription } from 'rxjs';
import { getRecursiveRouteData } from './page-view-tracking.helpers';
import { Tracking } from './tracking.service';

@Component({
  standalone: false,
  selector: 'fl-page-view-tracking',
  template: ` <ng-container></ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageViewTrackingComponent implements OnInit, OnDestroy {
  private activatedRoute = inject(ActivatedRoute);
  private tracking = inject(Tracking);
  private router = inject(Router);

  private trackPageViewSubscription?: Subscription;

  ngOnInit(): void {
    this.trackPageViewSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.tracking.trackPageView(
          getRecursiveRouteData(this.activatedRoute.snapshot).is404,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.trackPageViewSubscription?.unsubscribe();
  }
}
